module.exports = __webpack_public_path__ + "static/2-min-0a050d32d8505f12285882dbdecc081b.jpg";